import React from "react";
import { useParams, useLocation } from "react-router-dom";
import ProfileContainer from "./ProflieContainer";
import JoinedSessions from "./JoinedSessions";
import ViewableChessContent from "@/features/games/chess/components/game-dashboard/ViewableChessContent";
import ControlContainer from "./ControlContainer";
import type { User } from '@/shared/types';
import { GAME, GameState } from "@/shared/constants/game";
import { useAppSelector } from '@/store/hooks';
import { selectLeaderboardForTournament } from '@/store/slices/leaderboardSlice';
import { selectActiveTournament } from '@/store/slices/tournamentsSlice';
import ViewablePoolContent from "@/features/games/pool/components/game-dashboard/ViewablePoolContent";

function ShellSideContainer({ user, gameState } : { user: User | null, gameState: GameState }){
    const { sessionID, roomID } = useParams<{ sessionID?: string; roomID?: string }>();
    const location = useLocation();
    const { gameData } = location.state || {};
    const isInSession = !!sessionID || (gameState === GAME.POOL && !!roomID);

    // Get current round from Redux
    const tournamentId = gameData?.tournamentId || 0;
    const leaderboard = useAppSelector(state => selectLeaderboardForTournament(state, tournamentId));
    const activeTournament = useAppSelector(selectActiveTournament);

    // Get current round from leaderboard entries (they all have the same round)
    // or from tournament state, fallback to 1
    const currentRound = leaderboard[0]?.round ?? activeTournament?.currentRound ?? 1;

    return(
        <div className="dark-box dark-box-sidebar">
            <div className="gridMenu dark-box">
                <ProfileContainer user={user}/>

                {isInSession ? (
                    <>
                        {gameState === GAME.CHESS && (
                            <ViewableChessContent
                                user={user}
                                inGameSessionID={gameData?.tournamentId || 0}
                                gameID={gameData?.gameId || 0}
                                whiteID={gameData?.whiteId || 0}
                                blackID={gameData?.blackId || 0}
                                whiteUsername={gameData?.whiteUsername || ''}
                                blackUsername={gameData?.blackUsername || ''}
                                showChessGame={!!gameData?.gameId}
                                currentRound={currentRound}
                            />
                        )}
                        {gameState === GAME.POOL && sessionID && (
                            <ViewablePoolContent />
                        )}
                    </>
                ) : (
                    <JoinedSessions gameState={gameState}/>
                )}

                <ControlContainer/>
            </div>
        </div>
    )
}

export default ShellSideContainer
